exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-amount-simulation-errors{display:block}loans-amount-simulation-errors .errors{margin-bottom:15px;padding:15px;background-color:#fff}loans-amount-simulation-errors .errors p{color:#c8175e}loans-amount-simulation-errors .errors.mobile p{font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/components/loansAmountSimulation/loansAmountSimulationErrors/loansAmountSimulationErrors.scss
// module id = 2169
// module chunks = 0